export const colors = {
  // Primary
  rose: '#C46876',        // Primary brand color — CTAs, highlights, logo
  navy: '#002343',        // Primary text, headlines, trust-building

  // Secondary
  peach: '#DDC0B9',       // Hover states, secondary brand elements
  textMedium: '#45566D',  // Secondary body copy, muted text
  gold: '#FFB600',        // Borders, subtle accents, premium details

  // Backgrounds
  white: '#FFFFFF',
  offWhite: '#FFFFFE',
  cream: '#FDF9F4',       // Warm page background

  // Derived
  navyDark: '#001730',    // Darker navy for gradients/footers
  roseLight: '#E8A0AC',   // Lighter rose for hover
};

export const fonts = {
  heading: "'Cinzel', serif",
  body: "'Montserrat', sans-serif",
};
